module.exports = __webpack_public_path__ + "img/IMG_8629_T_L_Foamcore_MockedUp.2cd4e3e2.jpg";